import { morphism } from 'morphism';
import { createStrictSchema, createUnknownSchema } from '../../utils/morph.js';

const PromoDiscountSchema = createStrictSchema({
    receiptItem: 'receipt_item',
    type: 'type',
    value: 'value',
});
const assetsPromoSchema = createStrictSchema({
    resourceName: 'resource_name',
    resourceUrl: 'resource_url',
});
const countdownConfSchema = createStrictSchema({
    alternativeSubtitle: 'alternative_subtitle',
});
const PromoContentSchema = createStrictSchema({
    name: 'name',
    title: 'title',
    subtitle: 'subtitle',
    countdown: {
        path: 'countdown',
        fn: morphism(countdownConfSchema),
    },
    assets: {
        path: 'assets',
        fn: morphism(assetsPromoSchema),
    },
});
const paidOptionsPromoSchema = createUnknownSchema({
    name: 'name',
    start_date: 'startDate',
    end_date: 'endDate',
    purchased_products: 'purchasedProducts',
    gift_products: 'giftProducts',
    status: 'status',
    type: 'type',
    ad_ids: 'adIds',
    user_id: {
        path: 'userId',
        fn: (stringUserId) => Number.parseInt(stringUserId, 10),
    },
});
const infoPromoSchema = createStrictSchema({
    id: 'id',
    channels: 'channels',
    startDate: 'start_date',
    endDate: 'end_date',
    criteria: 'criteria',
    discounts: {
        path: 'discounts',
        fn: morphism(PromoDiscountSchema),
    },
    content: {
        path: 'content',
        fn: morphism(PromoContentSchema),
    },
});
const promotionsSchema = createStrictSchema({
    promo: {
        path: 'promotions',
        fn: morphism(infoPromoSchema),
    },
});
const validationItemSchema = createStrictSchema({
    productID: 'product_id',
    amount: 'amount',
    subtotalAmount: 'subtotal_amount',
});
const voucherValidatedOrderSchema = createStrictSchema({
    amount: 'amount',
    totalAmount: 'total_amount',
    items: {
        path: 'items',
        fn: morphism(validationItemSchema),
    },
});

export { PromoDiscountSchema, infoPromoSchema, paidOptionsPromoSchema, promotionsSchema, voucherValidatedOrderSchema };
//# sourceMappingURL=morph.js.map
